import { RootState } from 'redux/store';
import { createSelector } from '@reduxjs/toolkit';

const focusState = ({ focus }: RootState) => focus;

export const shouldFocusAliasInputSelector = createSelector(
  focusState,
  (state) => state.shouldFocusAliasInput
);
